/* Journi theme interactions */
(function () {
  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }

  ready(function () {
    // Mobile menu
    document.querySelectorAll('[data-menu-toggle]').forEach(function (btn) {
      var drawer = document.getElementById(btn.getAttribute('aria-controls'));
      btn.addEventListener('click', function () {
        var open = drawer.hidden;
        drawer.hidden = !open;
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });

    // Product gallery carousel
    document.querySelectorAll('[data-carousel]').forEach(function (root) {
      var track = root.querySelector('.j-track');
      var slides = track ? track.children.length : 0;
      if (!slides) return;
      var thumbs = root.querySelectorAll('[data-go]');
      var dots = root.querySelectorAll('.j-dots button');
      var i = 0;
      function go(n) {
        i = (n + slides) % slides;
        track.style.transform = 'translateX(-' + (i * 100) + '%)';
        thumbs.forEach(function (t) { t.setAttribute('aria-current', String(+t.getAttribute('data-go') === i)); });
        dots.forEach(function (d) { d.setAttribute('aria-current', String(+d.getAttribute('data-go') === i)); });
      }
      root.addEventListener('click', function (e) {
        var b = e.target.closest('[data-go],[data-step-dir]');
        if (!b) return;
        if (b.hasAttribute('data-go')) go(+b.getAttribute('data-go'));
        else go(i + (+b.getAttribute('data-step-dir')));
      });
      root.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') go(i - 1);
        if (e.key === 'ArrowRight') go(i + 1);
      });
      go(0);
    });

    // Scent finder
    document.querySelectorAll('[data-finder]').forEach(function (root) {
      var box = root.querySelector('[data-match]');
      root.querySelectorAll('[data-dest]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          root.querySelectorAll('[data-dest]').forEach(function (b) { b.setAttribute('aria-pressed', String(b === btn)); });
          box.style.background = btn.getAttribute('data-color');
          box.querySelector('[data-m-name]').textContent = btn.getAttribute('data-name');
          box.querySelector('[data-m-notes]').textContent = btn.getAttribute('data-notes');
          var link = box.querySelector('[data-m-link]');
          link.href = btn.getAttribute('data-url');
          link.textContent = 'Explore ' + btn.getAttribute('data-name');
          var img = box.querySelector('[data-m-img]');
          img.src = btn.getAttribute('data-img');
          img.alt = btn.getAttribute('data-name') + ' diffuser bottle';
          box.hidden = false;
        });
      });
    });

    // How it works steps
    document.querySelectorAll('[data-steps]').forEach(function (root) {
      root.addEventListener('click', function (e) {
        var b = e.target.closest('.j-step');
        if (!b) return;
        root.querySelectorAll('.j-step').forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
      });
    });

    // Scent quiz
    document.querySelectorAll('[data-quiz]').forEach(function (root) {
      var cfg = JSON.parse(root.querySelector('script[type="application/json"]').textContent);
      var answers = [];
      var el = function (s) { return root.querySelector(s); };
      var asking = el('[data-q-asking]'), done = el('[data-q-done]');
      var letters = ['A', 'B', 'C', 'D'];
      function showImg(key) {
        root.querySelectorAll('[data-q-img]').forEach(function (im) { im.hidden = im.getAttribute('data-q-img') !== key; });
      }
      function render() {
        var step = answers.length;
        if (step < cfg.questions.length) {
          var q = cfg.questions[step];
          asking.hidden = false; done.hidden = true;
          el('[data-q-num]').textContent = 'Question ' + (step + 1) + ' of ' + cfg.questions.length;
          el('[data-q-bar]').style.width = Math.round(step / cfg.questions.length * 100) + '%';
          el('[data-q-back]').hidden = step === 0;
          el('[data-q-title]').textContent = q.question;
          var list = el('[data-q-options]');
          list.innerHTML = '';
          q.options.forEach(function (o, i) {
            var b = document.createElement('button');
            b.type = 'button'; b.className = 'j-answer';
            var l = document.createElement('span'); l.className = 'j-mono'; l.setAttribute('aria-hidden', 'true'); l.textContent = letters[i];
            var t = document.createElement('span'); t.textContent = o.label;
            b.appendChild(l); b.appendChild(t);
            b.addEventListener('click', function () { answers.push(o.scent); render(); window.scrollTo({ top: root.offsetTop - 80, behavior: 'smooth' }); });
            list.appendChild(b);
          });
          showImg('q' + step);
        } else {
          var tally = {}; answers.forEach(function (a) { tally[a] = (tally[a] || 0) + 1; });
          var win = answers[answers.length - 1];
          Object.keys(tally).forEach(function (k) { if (tally[k] > tally[win]) win = k; });
          var s = cfg.scents[win];
          asking.hidden = true; done.hidden = false;
          el('[data-r-mood]').textContent = s.mood;
          el('[data-r-mood]').style.background = s.color;
          el('[data-r-name]').textContent = s.name;
          el('[data-r-notes]').textContent = s.notes;
          el('[data-r-story]').textContent = s.story;
          el('[data-r-score]').textContent = tally[win] + ' of ' + cfg.questions.length + ' answers pointed here';
          var img = el('[data-r-img]'); img.src = s.img; img.alt = s.name + ' diffuser bottle';
          var link = el('[data-r-link]'); link.href = s.url; link.textContent = 'See ' + s.name;
          showImg('r-' + win);
        }
      }
      el('[data-q-back]').addEventListener('click', function () { answers.pop(); render(); });
      el('[data-q-restart]').addEventListener('click', function () { answers = []; render(); });
      render();
    });
  });
})();
